export const EMPTY_LEAD = {
  consenso_privacy: false, consenso_tracking_email: false,
  nome_fiera: "", anno: 2026,
  ragione_sociale: "", paese: "", nome_buyer: "", ruolo: "", email: "", cellulare: "",
  lingua: [], sesso: "",
  tipologia_azienda: [],
  interesse_brand: [], interesse_prodotti: [],
  packaging_canale: [], formato: "",
  progetto_tipo: [], progetto_volume: [],
  campioni_stato: [], campioni_prodotti: "",
  priorita: "", potenziale: 0,
  note: "", card_photo: null,
};
